export default {
  title: {
    en: 'Choose a card design',
  },
}
